import React  from "react";
import { useSelector } from 'react-redux';
import {
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarFooter,
  CDBSidebarMenu,
  CDBSidebarMenuItem,
  CDBSidebarHeader,
} from 'cdbreact';
import { UserRoles } from '../../utils/helpers/enums';
import { NavigationLink } from './sidenav.styles';

const SideNav = () => {
  const { userData: {
    roles,
  } } = useSelector(state => state.entities.user);

  const menuItems = roles && roles.includes(UserRoles.admin) ? [
    { name: 'Overview', to: '/', icon: 'columns' },
    { name: 'Projects', to: '/projects', icon: 'users' },
    { name: 'Employees', to: '/employees', icon: 'users' },
    { name: 'Hours', to: '/hours', icon: 'clock' },
    { name: 'Expenses', to: '/expenses', icon: 'credit-card' },
  ] : [
    { name: 'Hours', to: '/', icon: 'clock' },
  ];

  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        overflow: 'scroll initial',
      }}
    >
      <CDBSidebar textColor="#fff" backgroundColor="#333">
        <CDBSidebarHeader prefix={<i className="fa fa-bars fa-large"></i>}>
          Menu
        </CDBSidebarHeader>

        <CDBSidebarContent>
          <CDBSidebarMenu>
            {menuItems.map(({ name, to, icon }, index) => (
              <NavigationLink key={index} to={to}>
                <CDBSidebarMenuItem icon={icon}>{name}</CDBSidebarMenuItem>
              </NavigationLink>
            ))}
          </CDBSidebarMenu>
        </CDBSidebarContent>

        <CDBSidebarFooter style={{ padding: '1rem 0.5rem', }}>
          <CDBSidebarMenu>
            <NavigationLink to="/logout">
              <CDBSidebarMenuItem icon={'sign-out-alt'}>Logout</CDBSidebarMenuItem>
            </NavigationLink>
          </CDBSidebarMenu>
          <div style={{ textAlign: 'center' }}>Projects App</div>
        </CDBSidebarFooter>
      </CDBSidebar>
    </div>
  );
};

export default SideNav;
